"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dropzone = void 0;
var tslib_1 = require("tslib");
var kebabCase_1 = (0, tslib_1.__importDefault)(require("lodash/kebabCase"));
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
var test_helpers_1 = require("../../lib/test-helpers");
var theme_1 = require("../../theme");
var flexbox_1 = require("../flexbox");
var padding_1 = require("../padding");
var spinner_1 = require("../spinner");
var text_1 = require("../text");
function IconPlus() {
    return (react_1.default.createElement("svg", { width: "12", height: "12", viewBox: "0 0 12 12" },
        react_1.default.createElement("path", { d: "M10.6565 4.875H7.28149V1.5C7.28149 1.08586 6.94563 0.75 6.53149 0.75H5.78149C5.36735 0.75 5.03149 1.08586 5.03149 1.5V4.875H1.65649C1.24235 4.875 0.906494 5.21086 0.906494 5.625V6.375C0.906494 6.78914 1.24235 7.125 1.65649 7.125H5.03149V10.5C5.03149 10.9141 5.36735 11.25 5.78149 11.25H6.53149C6.94563 11.25 7.28149 10.9141 7.28149 10.5V7.125H10.6565C11.0706 7.125 11.4065 6.78914 11.4065 6.375V5.625C11.4065 5.21086 11.0706 4.875 10.6565 4.875Z", fill: theme_1.colors.primary })));
}
function Dropzone(props) {
    var label = props.label, onClick = props.onClick, isLoading = props.isLoading, _a = props.disabled, disabled = _a === void 0 ? false : _a, style = props.style, propTestId = props.testId;
    var testId = propTestId !== null && propTestId !== void 0 ? propTestId : (0, test_helpers_1.generateTestId)((0, kebabCase_1.default)(label), 'dropzone');
    function noop() { }
    function onKeyDown(e) {
        if (e.key === ' ' && onClick) {
            onClick();
        }
    }
    return (react_1.default.createElement(StyledDiv, { className: "dropzone", onKeyDown: !disabled ? onKeyDown : noop, onClick: !disabled ? onClick : noop, role: "button", tabIndex: 0, disabled: disabled, style: style, "data-testid": testId },
        react_1.default.createElement(padding_1.Padding, { size: 16, width: "100%" },
            react_1.default.createElement(flexbox_1.Flexbox, { alignItems: "center", justifyContent: "center", style: {
                    position: 'relative',
                    minHeight: 23,
                } }, isLoading ? (react_1.default.createElement(spinner_1.Spinner, null)) : (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(padding_1.Padding, { right: 8 },
                    react_1.default.createElement(IconPlus, null)),
                react_1.default.createElement(text_1.Text, { textAlign: "center", color: "active", weight: 600 }, label)))))));
}
exports.Dropzone = Dropzone;
var StyledDiv = styled_components_1.default.div(templateObject_1 || (templateObject_1 = (0, tslib_1.__makeTemplateObject)(["\n  cursor: ", ";\n  border: 1px dashed #dbdbdb;\n  display: flex;\n  border-radius: 6px;\n  pointer-events: ", ";\n  opacity: ", ";\n  outline: none;\n\n  :hover,\n  :focus {\n    background-color: ", ";\n    border-color: ", ";\n  }\n"], ["\n  cursor: ", ";\n  border: 1px dashed #dbdbdb;\n  display: flex;\n  border-radius: 6px;\n  pointer-events: ", ";\n  opacity: ", ";\n  outline: none;\n\n  :hover,\n  :focus {\n    background-color: ", ";\n    border-color: ", ";\n  }\n"])), function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'not-allowed' : 'pointer');
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'none' : 'initial');
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? '0.4' : '1');
}, theme_1.colors.primary_xxxl, theme_1.colors.primary);
var templateObject_1;
//# sourceMappingURL=index.js.map